export const propMiscModals = {
  policia: {
    title: "Register details",
    heading: "Register the details of the competent authorities",
    subtitle:
      "Automatically sync your property's check-ins with the authorities",
    entityLabel: "Entity name",
    entityPlaceholder: "Select an entity",
    userLabel: "Username",
    passwordLabel: "Password",
    accessError:
      "Check your access credentials; we recommend not trying more than three times or you may lock your account.",
    validateBtn: "Validate",
    saveBtn: "Save details",
    entityRequired: "The entity is required",
    usernameRequired: "The username is required",
    passwordRequired: "You must enter the password",
    validateError: "Error while validating the details",
    saveError: "Error saving the immigration police details",
  },
  upgrade: {
    heading: "Upgrade your plan to keep creating properties",
    message:
      "Hi! We noticed you've reached the limit of properties allowed on your current plan.",
    button: "Upgrade plan",
  },
};
